import PropostaTerapeuticaList from "./page/PropostaTerapeuticaList.vue";
import PropostaTerapeuticaEdit from "./page/PropostaTerapeuticaEdit.vue";
import PropostaTerapeuticaView from "./page/PropostaTerapeuticaView.vue";

export default {
    PropostaTerapeuticaList,
    PropostaTerapeuticaEdit,
    PropostaTerapeuticaView,
};
